import { render, staticRenderFns } from "./WorkItemOrder.vue?vue&type=template&id=2f538a33&"
import script from "./WorkItemOrder.vue?vue&type=script&lang=js&"
export * from "./WorkItemOrder.vue?vue&type=script&lang=js&"
import style0 from "./WorkItemOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports